import { formatTimer, mapGaugesProperties } from 'app/utils/entities/match_data';

const getValueFromScale = (value: number | undefined, scale: RadarChartMinMax) =>
  value === undefined ? 0 : Math.round(((value - scale.min) / (scale.max - scale.min)) * 100);

const getLolTeamStatsLines = (data: {
  opponents: OpponentWithTeamStats[];
}): GaugeStatLine<StatsLol>[] => {
  const opponent1Stat = data?.opponents.at(0)?.stats as StatsLol | undefined;
  const opponent2Stat = data?.opponents.at(1)?.stats as StatsLol | undefined;

  // Sort properties in this array by wanted display order
  const properties: GaugeStatProperties<StatsLol>[] = [
    { name: 'first_blood_percentage', highlighted: 'max' },
    { name: 'red_side_winrate', highlighted: 'max', variation: 'vg_lol_red' },
    { name: 'blue_side_winrate', highlighted: 'max', variation: 'vg_lol_blue' },
    { name: 'average_game_time', absoluteValue: true, displayFunction: formatTimer }
  ];
  return mapGaugesProperties(properties, opponent1Stat, opponent2Stat);
};

export { getValueFromScale, getLolTeamStatsLines };
